import * as React from 'react';

import ImageCampaign from '@/assets/images/guide/img_campaign@2x.png';
import ImageMission from '@/assets/images/guide/img_mission@2x.png';
import Button from '@/components/elements/Button/BaseButton';
import { SpBr } from '@/components/layouts/Modal/Guest/style';

import { Container } from './style';

export interface CampaignProps {
  closeModal: () => void;
}

const CampaignContent: React.FC<CampaignProps> = ({ closeModal }) => {
  return (
    <Container>
      <h2>お得なキャンペーン実施中</h2>
      <p>
        DMM競輪では様々なお得なキャンペーンを実
        <SpBr />
        施しています！ご参加をお待ちしております。
      </p>
      <img src={ImageCampaign} alt="Campaign" />
      <h3>新規ユーザー様限定ミッションも実施！</h3>
      <p>
        ミッション達成で必ずtoreta+ がゲットでき
        <SpBr />
        ます。この機会にぜひチャレンジしてくださ
        <SpBr />
        い！
      </p>
      <img src={ImageMission} alt="Mission" />
      <div>
        <Button
          size="m"
          bgColor="primary"
          fontWeight="bold"
          height="56px"
          radius="l"
          onClick={() => {
            closeModal();
          }}
        >
          DMM競輪をはじめる
        </Button>
      </div>
    </Container>
  );
};

export default CampaignContent;
